<!-- <p>admin-usergroup works!</p> -->
<div class="main-panel">
    <div class="d-flex">
        <div>
            <div class="mb-1 fw-600">Client Name</div>
            <app-multi-select-dropdown
                id="selectedClient"
                class="multi-select-option form-control shadow-sm multi-select-client"
                [items]="clientsList"
                [selectedItems]="selectedClientItems"
                displayname="name"
                selectedProp="id"
                [selectedCountText]="selectedClientCountText"
                [selectedBlankText]="selectedClientBlankText"
                (selectedItemsChange)="onSelectionClientChange($event)"
            ></app-multi-select-dropdown>
        </div>

        <div class="margin-client-search">
            <div class="d-flex pt-4">
                <div class="h-30p">
                    <input
                        type="text"
                        class="form-control text-box-size shadow-sm client-search-input"
                        placeholder="Search"
                        [attr.id]="'gyan-client-textbox'"
                        [attr.data-test]="'gyan-client-textbox'"
                        [(ngModel)]="searchText"
                        (keyup.enter)="SearchList()"
                        (input)="onSearchTextChange()"
                    />
                    <div class="cursor-pointer clear-icon icon-pos" (click)="clearSearch()" *ngIf="searchText !== ''"></div>
                </div>

                <div class="form-control search-client"></div>

                <div class="cursor-pointer search-term-icon" (click)="userGroupSearchTermSearch()"></div>
            </div>
        </div>
        <!-- <p>admin-usergroup works!</p> -->
        <div class="d-flex" class="submit-button pt-4">
            <button class="create-button d-flex" #createButton (click)="openUserGroupCreationForm(UserGroupCreateAndEditModel)">
                <div class="icon-plus"></div>
                <div class="pl-3p">Create User Group</div>
            </button>
        </div>
    </div>

    <div class="table-container">
        <div
            [ngClass]="{
                'height-table-div': userGroups?.length == 10,
                'height-table-div-overflow': userGroups?.length < 10 && userGroups?.length <= 4,
            }"
        >
            <table class="custom-table" [ngClass]="{ 'custom-table-loading': isLoadingData }">
                <thead class="custom-table-head">
                    <tr>
                        <th class="w-25">User Group Name</th>
                        <th class="w-25">Label</th>
                        <th class="w-10p">User Group Type</th>
                        <th class="w-25">Access</th>
                        <th class="w-15 actions-text">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="userGroups?.length > 0 && !isLoadingData">
                        <tr *ngFor="let group of userGroups; let i = index" class="h-35p">
                            <td>
                                <div class="display-ellipsis" title="{{ group.name }}">
                                    {{ group.name }}
                                </div>
                            </td>
                            <td>
                                <div class="display-ellipsis" title="{{ group.label }}">
                                    {{ group.label }}
                                </div>
                            </td>
                            <td>
                                <div class="display-ellipsis">
                                    {{ group.userGroupType }}
                                </div>
                            </td>
                            <td>
                                <div
                                    class="actions-container d-flex"
                                    [ngClass]="{ 'actions-container-position': userGroups?.length < 10 || (userGroups?.length === 10 && i + 1 > 5) }"
                                >
                                    <div
                                        class="cursor-pointer"
                                        (click)="toggleList(i, $event)"
                                        [ngClass]="{ 'icon-active-eye': activeAccessList === i, 'icon-eye': activeAccessList != i }"
                                    ></div>
                                    <div class="display-ellipsis">
                                        {{ group.accessNames | truncateWords: 5 }}
                                    </div>
                                    <!-- <div style="overflow: scroll;font-style: italic;padding: 10px;max-height: 130px;overflow-y: scroll;font-style: italic;width: 210px;overflow-x: hidden;" class="popup-access" *ngIf="activeAccessList === i">
                                        <ul *ngFor="let access of group.accessList" class="d-flex popup-container" style="margin-bottom: 0.5rem;padding-left: 1rem">
                                            <li>{{ access.label }}</li>
                                        </ul>
                                    </div> -->
                                    <div
                                        class="access-popup-position"
                                        [ngClass]="{
                                            'popup-access': userGroups?.length === 10 && i + 1 <= 5,
                                            'popup-up-access': userGroups?.length < 10 || (userGroups?.length === 10 && i + 1 > 5),
                                        }"
                                        *ngIf="activeAccessList === i"
                                    >
                                        <ul *ngFor="let access of group.accessList" class="d-flex popup-container label-style">
                                            <li class="label-white-space">{{ access.label }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </td>
                            <td class="actions-text">
                                <div class="actions-container">
                                    <fa-icon (click)="togglePopup(i, $event)" class="p-1 cursor-pointer d-flex align-items-center align-vertical-item" [icon]="faEllipsisV">
                                    </fa-icon>
                                    <div
                                        *ngIf="activePopupIndex === i"
                                        [ngClass]="{
                                            'popup-down': !(userGroups.length >= 9 && i >= userGroups.length - 2),
                                            'popup-up': userGroups.length >= 9 && i >= userGroups.length - 2,
                                        }"
                                    >
                                        <div class="d-flex cursor-pointer popup-container" (click)="editGroup(group, UserGroupCreateAndEditModel)">
                                            <div class="edit-icon"></div>
                                            <div class="popup-item">Edit</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>

                    <tr *ngIf="userGroups?.length === 0">
                        <td colspan="5" class="no-user-text">No User groups available with searched text</td>
                    </tr>
                    <tr *ngIf="isLoadingData">
                        <td colspan="5" class="text-center text-secondary">
                            <div class="p-1">
                                <div class="d-flex justify-content-center">
                                    <div class="padding-summary">Loading..</div>
                                    <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="display-pagination" [ngClass]="{ 'display-mobile-pagination': isMobile }" *ngIf="!isLoadingData && userGroups?.length > 0">
                <div>{{ startItem }} to {{ endItem }} Items of {{ totalItems }}</div>
                <div class="user-pagination pt-2 px-2">
                    <pagination
                        [totalItems]="totalItems"
                        [(ngModel)]="currentPage"
                        [maxSize]="5"
                        class="justify-content-center pagination mb-0 px-0"
                        previousText="&lsaquo;"
                        nextText="&rsaquo;"
                        firstText="&laquo;"
                        lastText="&raquo;"
                        [boundaryLinks]="true"
                        [rotate]="false"
                        (pageChanged)="onPageChanged($event)"
                    >
                    </pagination>
                </div>
            </div>
        </div>
    </div>

    <!-- <div *ngIf="showcreateandEditForm" class="overlay"></div> -->

    <ng-template #UserGroupCreateAndEditModel let-modal>
        <div>
            <div class="modal-dialog m-0">
                <div class="modal-content text-center">
                    <div class="modal-header fw-600 create-ug-header">
                        <div *ngIf="!disableForm">Create User Group</div>
                        <div *ngIf="disableForm">Edit User Group</div>
                        <!-- <div class="cursor-pointer btn-close close-form" (click)="closeCreateandEditForm()"></div> -->
                        <div
                            type="button"
                            class="gyan-popup-close"
                            aria-label="Close"
                            (click)="closeCreateandEditForm()"
                            [attr.id]="'usergroup-modal-close'"
                            [attr.data-test]="'usergroup-modal-close'"
                        >
                            <div class="modal-close-icon"></div>
                        </div>
                    </div>
                    <div class="modal-body ug-form-body">
                        <div class="mb-3">
                            <div class="label-form">User Group Name</div>
                            <div class="ug-name-div">
                                <input
                                    type="text"
                                    class="form-control text-box-size shadow-sm ug-name"
                                    placeholder="Enter User Group Name"
                                    [attr.id]="'gyan-client-textbox'"
                                    [attr.data-test]="'gyan-client-textbox'"
                                    [(ngModel)]="userGroupnameText"
                                    [disabled]="disableForm"
                                    (keypress)="restrictInput($event)"
                                    (blur)="validateField('userGroupnameText')"
                                />
                                <div class="error-message" *ngIf="errors['userGroupnameText']">
                                    {{ errors['userGroupnameText'] }}
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="label-form">Label</div>
                            <div class="ug-desc-div">
                                <input
                                    type="text"
                                    class="form-control text-box-size shadow-sm ug-desc-input"
                                    placeholder="Enter Label"
                                    [attr.id]="'gyan-client-textbox'"
                                    [attr.data-test]="'gyan-client-textbox'"
                                    [(ngModel)]="descriptionText"
                                />
                            </div>
                        </div>

                        <div class="mb-3">
                            <div class="label-form">Client Name</div>
                            <div class="ug-form-client-pos select-input" [ngClass]="{ 'select-input-error': errors['searchTerm'] }">
                                <input
                                    type="text"
                                    placeholder="Select"
                                    [(ngModel)]="searchTerm"
                                    (focus)="toggleDropdown(true)"
                                    (input)="filterClients()"
                                    (blur)="hideDropdown()"
                                    [readonly]="selectedClient"
                                    class="form-control shadow-sm ug-form-client"
                                    [disabled]="disableForm"
                                    (blur)="validateField('searchTerm')"
                                />
                                <div class="error-message" *ngIf="errors['searchTerm']">
                                    {{ errors['searchTerm'] }}
                                </div>
                                <div *ngIf="selectedClient && !disableForm" class="cursor-pointer clear-icon-small clear-pos-client" (click)="clearSelection()">x</div>
                                <ul *ngIf="isDropdownOpen && filteredClients.length" class="ug-client-list">
                                    <li
                                        *ngFor="let client of filteredClients"
                                        (mousedown)="selectClient(client)"
                                        class="ug-list-client"
                                        [style.background]="client === selectedClient ? '#007bff' : 'transparent'"
                                        [style.color]="client === selectedClient ? 'white' : 'black'"
                                    >
                                        {{ client }}
                                    </li>
                                    <li *ngIf="filteredClients.length === 0" class="no-clients">No matching clients</li>
                                </ul>
                            </div>
                        </div>

                        <div class="mb-3">
                            <div class="label-form">User Group Type</div>
                            <div class="select-dropdown" [ngClass]="{ 'select-dropdown-error': errors['selectedRole'] }">
                                <select
                                    id="userRole"
                                    class="form-control ug-form-type"
                                    [(ngModel)]="selectedRole"
                                    #roleSelect
                                    (change)="onChangeUserGroup(roleSelect.value)"
                                    (blur)="validateField('selectedRole')"
                                >
                                    <option value="" disabled selected>Select</option>
                                    <option class="font-14" *ngFor="let role of roles" [value]="role">{{ role }}</option>
                                </select>
                                <div class="error-message" *ngIf="errors['selectedRole']">
                                    {{ errors['selectedRole'] }}
                                </div>
                            </div>
                        </div>

                        <div class="label-form">Access</div>
                        <div class="access-dropdown">
                            <app-multi-select-dropdown
                                id="selectedClient"
                                class="multi-select-option form-control shadow-sm access-form"
                                [items]="options"
                                [selectedItems]="selectedAccessItems"
                                selectedProp="id"
                                displayname="label"
                                [selectedCountText]="selectedAccessCountText"
                                [selectedBlankText]="selectedAccessBlankText"
                                (selectedItemsChange)="onSelectionAccessChange($event)"
                            ></app-multi-select-dropdown>
                            <div class="error-message" *ngIf="errors['selectedAccessItems']">
                                {{ errors['selectedAccessItems'] }}
                            </div>
                        </div>

                        <div class="mt-3">
                            <div class="d-flex justify-content-end pt-30p">
                                <button class="create-btn" *ngIf="!disableForm" (click)="createNewUserGroup()" [disabled]="!isFormValid()">Create</button>
                                <button class="create-btn" *ngIf="disableForm" (click)="createNewUserGroup()" [disabled]="!isFormValid()">Save</button>
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
